export default __webpack_public_path__ + "static/media/movie.5058d57d.svg";